import { Button } from '@/components/ui/Button';
interface GameOverProps {
  finalScore: number;
  bestScore: number;
  isNewBest: boolean;
  onRestart: () => void;
  onMenu: () => void;
}
export function GameOver({
  finalScore,
  bestScore,
  isNewBest,
  onRestart,
  onMenu,
}: GameOverProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div
        className="bg-white rounded-3xl shadow-[0_25px_80px_-20px_rgba(0,0,0,0.4)] p-8 w-full max-w-[340px] flex flex-col items-center"
        style={{
          animation: 'popIn 0.3s ease-out',
        }}
      >
        <div className="w-20 h-20 bg-[#E63946] rounded-full flex items-center justify-center shadow-[4px_4px_0_0_#991B1B] mb-6">
          <svg
            className="w-10 h-10 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2.5}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h2 className="text-3xl font-extrabold text-[#1a1a1a] mb-2">
          Game Over!
        </h2>
        {isNewBest && (
          <div className="bg-[#FFD93D] text-[#1a1a1a] font-bold px-4 py-1 rounded-full text-sm mb-4 shadow-[2px_2px_0_0_#B8860B]">
            New Best Score!
          </div>
        )}
        <div className="text-center mb-8">
          <p className="text-sm font-medium text-[#6B7280] uppercase tracking-wider mb-1">
            Final Score
          </p>
          <p className="text-5xl font-extrabold text-[#1a1a1a] tabular-nums">
            {finalScore}
          </p>
          {finalScore < bestScore && (
            <p className="text-sm text-[#6B7280] mt-2">
              Best: <span className="font-bold text-[#FFD93D]">{bestScore}</span>
            </p>
          )}
        </div>
        <div className="flex flex-col gap-3 w-full">
          <Button onClick={onRestart} variant="primary">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            Play Again
          </Button>
          <Button onClick={onMenu} variant="secondary">
            Main Menu
          </Button>
        </div>
      </div>
      <style>{`
        @keyframes popIn {
          0% {
            opacity: 0;
            transform: scale(0.8);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
}